module.exports = __webpack_public_path__ + "static/media/zoomy4_preview.6dc17ed0.jpg";